import styled from 'styled-components'
import { Input } from 'components/common/FormElements/Input'

export default styled(Input)`
  vertical-align: middle;
  padding-bottom: 15px;
  width: 62%;

  label[data-error-message] {
    margin-top: 5px;
    position: initial;
    display: block;
    white-space: normal;
  }
`
